import React, { FC } from 'react';
import { Select, DatePicker } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Form } from '~/components';
import { usePath } from '~/hooks';
import EmployeeInput from '~/components/inputs/EmployeeInput';
import { inputWidth, dateWidth } from '~/utils/filters';

const Filters: FC<any> = () => {
  const [form] = Form.useForm();
  const { changePath, params } = usePath();
  const { t } = useTranslation('payrolls');

  const handleChange = (changed: any, values: Record<string, any>) => {
    const { fromCreatedAt, toCreatedAt, ...rest } = values;
    const filter = {
      fromCreatedAt: fromCreatedAt?.toISOString(),
      toCreatedAt: toCreatedAt?.toISOString(),
      ...rest,
    };
    changePath({ filter });
  };

  const handleInitialValues = (values?: Record<string, any>): Record<string, any> | undefined => {
    if (!values) return;
    const { fromCreatedAt, toCreatedAt, ...rest } = values;
    const filter = {
      fromCreatedAt: fromCreatedAt ? moment(fromCreatedAt) : undefined,
      toCreatedAt: toCreatedAt ? moment(toCreatedAt) : undefined,
      ...rest,
    };
    // eslint-disable-next-line consistent-return
    return filter;
  };

  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleChange}
      initialValues={handleInitialValues(params.filter)}
    >
      <Form.Item name="fromCreatedAt">
        <DatePicker showTime placeholder={t('Date from')} style={dateWidth} />
      </Form.Item>
      <Form.Item name="toCreatedAt">
        <DatePicker showTime placeholder={t('Date to')} style={dateWidth} />
      </Form.Item>
      <Form.Item name="status">
        <Select
          placeholder={t('Status')}
          allowClear
          options={[
            { value: 'INITIAL', label: t('INITIAL') },
            { value: 'IN_PROGRESS', label: t('IN_PROGRESS') },
            { value: 'COMPLETED_WITH_ERRORS', label: t('COMPLETED_WITH_ERRORS') },
            { value: 'REJECTED', label: t('REJECTED') },
            { value: 'COMPLETED', label: t('COMPLETED') },
          ]}
          style={inputWidth}
        />
      </Form.Item>
      <Form.Item name="actorId">
        <EmployeeInput placeholder={t('Employee')} style={inputWidth} />
      </Form.Item>
    </Form>
  );
};

export default Filters;
